import { render, staticRenderFns } from "./GYXPZ.vue?vue&type=template&id=2ff98dc6&scoped=true"
import script from "./GYXPZ.vue?vue&type=script&lang=js"
export * from "./GYXPZ.vue?vue&type=script&lang=js"
import style0 from "./GYXPZ.vue?vue&type=style&index=0&id=2ff98dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff98dc6",
  null
  
)

export default component.exports